/*
 * Compact product card enhancements — shared by search results and collection pages.
 * Adds the dark "% OFF" corner badge and swaps "Rs." for the rupee glyph.
 * Re-runs when a grid is replaced (collection filtering / sorting / pagination swap the DOM).
 */
(function () {
  function toNumber(t) {
    if (!t) return NaN;
    var m = t.replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function addBadges(scope) {
    var prices = scope.querySelectorAll('.price--on-sale');
    for (var i = 0; i < prices.length; i++) {
      var price = prices[i];
      var card = price.closest('.card');
      if (!card || card.querySelector('.pct-off')) continue;
      var sEl = price.querySelector('.price__sale s');
      var saleEl = price.querySelector('.price-item--sale');
      var mrp = toNumber(sEl && sEl.textContent);
      var sp = toNumber(saleEl && saleEl.textContent);
      if (mrp && sp && mrp > sp) {
        var pct = Math.round(((mrp - sp) / mrp) * 100);
        if (pct >= 1) {
          var b = document.createElement('span');
          b.className = 'pct-off';
          b.textContent = pct + '% OFF';
          card.appendChild(b);
        }
      }
    }
  }

  function toRupee(scope) {
    var rs = String.fromCharCode(8377);
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('Rs.') !== -1) {
        n.nodeValue = n.nodeValue.replace(/Rs\.\s?/g, rs);
      }
    }
  }

  function enhance() {
    var grids = document.querySelectorAll('.product-grid');
    for (var i = 0; i < grids.length; i++) {
      addBadges(grids[i]);
      toRupee(grids[i]);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      enhance();
    });
  }

  function watch() {
    enhance();
    // Collection filter/sort/paginate swaps #ProductGridContainer's contents via facets.js.
    // Search has no such container and renders once, so there is nothing to observe there.
    var root = document.querySelector('#ProductGridContainer');
    if (!root) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
